import { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../components/PageHeader";
import SHIELD_ICON from "../images/shield.svg";
import {
    setOtp,
    setOtpError,
    setPageError,
    setPageSuccess,
    setShowAadharBtn,
    setTimer,
} from "./CkycInputSlice";
import "./ckycStyles.scss";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRedirectToDigiMutation, useResendCKYCOtpMutation, useVerifyCKYCOtpMutation, useTriggetCkycOtpMutation } from '../lib/services/kycApi';
import {  useGetBasicDetailsMutation } from '../lib/services/eligibilityApi';

import { generateChecksum } from '../lib/middleware/generateChecksum';


const CkycOtpInput = () => {
    const dispatch = useDispatch();
    const { pageerror, pagesuccess, otp, showAadharBtn, otperror, timer } =
        useSelector((state) => state.ckyc);
    const [loader, setLoader] = useState(false);
    const [disableResend, setDisableResend] = useState(false);
    const [keyboardOpen, setKeyboardOpen] = useState(false); // <-- NEW
    const inputRefs = useRef(Array(6).fill(null));
    const [verifyCKYCOtp] = useVerifyCKYCOtpMutation();
    const [resendCKYCOtp] = useResendCKYCOtpMutation();
    const [redirectToDigi] = useRedirectToDigiMutation();
    const [triggetCkycOtp] = useTriggetCkycOtpMutation();
    const [getCustomerDetails] = useGetBasicDetailsMutation();
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const retryCount = useRef(0);

    // Calling OTP api on page load
  useEffect(() => {
      (async () => {
          try {
              const jwt_token = jwt ?? localStorage.getItem("jwt");
              const scrt = secret ?? localStorage.getItem("secret");
              const otpResp = await triggetCkycOtp({ jwt_token, scrt }).unwrap();
              if (otpResp?.status === "success") {
                  localStorage.setItem("ckycTransactionId", otpResp?.transaction_id || "");
                  dispatch(setPageSuccess(otpResp?.message));
              }
          } catch (error) {
              console.log("error in /triggetCkycOtp api", error);
          }
      })()
  }, [])

  const getCustomerDetailsAPI = async () => {
      try {
          let jwt_token = jwt ? jwt : localStorage.getItem('jwt');
          let scrt = secret ? secret : localStorage.getItem('secret');
          const result = await getCustomerDetails({ jwt_token, scrt });
          if (result.data?.redirect_url) {
              window.location.href = result.data?.redirect_url;
              // clevertapIdentitySet({identity: result.data?.data?.id});
          }
          if (result.error) {
              console.log(`customer_details_error <<${result.error.data.error_message}>> || error_code <<${result.error.data.error_code}>>`);
          }
      } catch (error) {
          console.log("error in /getCustomerDetails api", error);
      }
  }

    // OTP COMPONENT RELATED
    // Ensure OTP always has 6 characters (empty if not set)
    const otpArray = Array.from({ length: 6 }, (_, i) => otp?.[i] || "");

    // Handle OTP input changes
    const handleChange = (index, e) => {
        const value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
        if (!value) return;

        const newOtp = [...otpArray];
        newOtp[index] = value.charAt(0); // Store only one digit
        dispatch(setOtp(newOtp.join("")));

        // Move focus to the next field
        if (index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    // Handle Backspace: Clear input and move focus back
    const handleKeyDown = (index, e) => {
        dispatch(setOtpError(false));
        if (e.key === "Backspace") {
            const newOtp = [...otpArray];

            if (otpArray[index]) {
                // Clear current field
                newOtp[index] = "";
                dispatch(setOtp(newOtp.join("")));
            } else if (index > 0) {
                // Move focus to previous field and clear it
                newOtp[index - 1] = "";
                dispatch(setOtp(newOtp.join("")));
                inputRefs.current[index - 1]?.focus();
            }
        }
    };

    // --------XXXXXX---------XXXXXXX-------------END

    // RESENDING OTP FUNCTION
    // const reSendOtp = async () => {
    //     setLoader(true);
    //     dispatch(setPageError(""));
    //     dispatch(setPageSuccess(""));
    // try {
    //   const response = await apiRequest(
    //     "POST",
    //     ENDPOINTS.ckycOtpResend,
    //     { ckyc_id: localStorage.getItem("ckycTrnsactionId") }
    //   );
    //   if (response.mainData && response.mainData.status === "success") {
    //     dispatch(setPageSuccess("OTP sent successfully"));
    //   }
    //   if (response.mainData && response.mainData.status === "error") {
    //     dispatch(setPageError(response.mainData?.message));
    //   }
    //   if (response.mainData && response.mainData.status === "disburse") {
    //     dispatch(setPageError(response.mainData.message));
    //     setDisableResend(true);
    //   }
    //   if (response.error) {
    //     dispatch(setPageError(response.error));
    //   }
    // } catch (error) {
    //   dispatch(setPageError("Error in sending OTP"));
    // } finally {
    //   setLoader(false);
    // }
    // };
    const reSendOtp = async () => {
        setLoader(true);
        dispatch(setPageError(""));
        dispatch(setPageSuccess(""));
        retryCount.current = retryCount.current+=1;
        if(retryCount.current > 3){
            handleCKYCwithAdhar()
            return;
        }
        try {
            const jwt_token = jwt ?? localStorage.getItem("jwt");
            const scrt = secret ?? localStorage.getItem("secret");
            const ckyc_id = localStorage.getItem("ckycTrnsactionId") || "";
            const checksum = generateChecksum({
                mode: "okyc_v2_get_data",
                ckyc_id
            });

            const payload = {
                jwt_token,
                scrt,
                ckyc_id,
                checksum
            };

            const response = await resendCKYCOtp(payload).unwrap();

            if (response?.error) {
                dispatch(setPageError(response.message));
            } else if (response?.data?.status === "success") {
                dispatch(setPageSuccess("OTP sent successfully"));
            } else if (response?.data?.status === "error") {
                dispatch(setPageError(response.data?.message));
            } else if (response?.data?.status === "disburse") {
                dispatch(setPageError(response.data.message));
                setDisableResend(true);
            }
        } catch (error) {
            dispatch(setPageError("Error in sending OTP"));
        } finally {
            setLoader(false);
        }
    };

    // Handle Resend OTP
    const handleResend = () => {
        dispatch(setOtp(null)); // Clear Redux OTP state
        dispatch(setPageError(null));
        dispatch(setTimer(90)); // Reset timer
        dispatch(setShowAadharBtn(true));
        // Call your OTP generation API here
        reSendOtp();
    };

    // Timer countdown logic
    useEffect(() => {
        if (timer <= 0) {
            // dispatch(setOtpSent(false)); // Enable Resend button
            return;
        }

        const countdown = setInterval(() => {
            dispatch(setTimer(Math.max(timer - 1, 0)));
        }, 1000);

        return () => clearInterval(countdown);
    }, [timer, dispatch]);

    // Format seconds into MM:SS
    const formatTime = () => {
        const minutes = Math.floor(timer / 60);
        const seconds = timer % 60;
        return `${minutes.toString().padStart(2, "0")}:${seconds
            .toString()
            .padStart(2, "0")}`;
    };

    const handleVerifyOTP = async () => {
        setLoader(true);
        dispatch(setPageError(""));

        try {
            const jwt_token = jwt ?? localStorage.getItem("jwt");
            const scrt = secret ?? localStorage.getItem("secret");
            const ckyc_id = localStorage.getItem("ckycTransactionId") || "";

            const response = await verifyCKYCOtp({
                jwt_token,
                scrt,
                otp,
                ckyc_id,
            }).unwrap();
            if(response?.status === "success") {
                getCustomerDetailsAPI();
            }
            if (response?.error) {
                dispatch(setOtpError(true));
                dispatch(setShowAadharBtn(true));
                dispatch(setPageError(response.message || "Please try again."));
            } else if (response?.data?.status === "retry") {
                dispatch(setOtpError(true));
                dispatch(setShowAadharBtn(true));
                dispatch(setPageError(response.data.message || "Please try again."));
            }
        } catch (error) {
            dispatch(setPageError("Something went wrong. Please try again later."));
        } finally {
            setLoader(false);
        }
    };


    const handleCKYCwithAdhar = async () => {
        setLoader(true)
        try {
            const jwt_token = jwt ?? localStorage.getItem("jwt");
            const scrt = secret ?? localStorage.getItem("secret");
            const response = await redirectToDigi({ jwt_token, scrt }).unwrap();
            if(response?.success) {
                window.location.href = response?.data?.redirect_url;
            } else {
                dispatch(setPageError(response?.data?.message || "Something went wrong. Please try again later."));
            }
        } catch (error) {
            console.log("error in /redirect/digilocker api", error);
        } finally {
            setLoader(false);
        }
    };
    return (
        <div className="main_ckyc_container page-content">
            <PageHeader />
            <div className="ckyc_conainer">
                <p style={{ fontSize: 24, fontWeight: 700 }}>Instant KYC verification</p>
                <p className="description">
                    We will securely fetch your records from the Central KYC registry.
                    <span> Just Verify via OTP</span>
                </p>

                <div className="otpInputs">
                    {otpArray.map((digit, index) => {
                        // Find the last filled digit index (or first empty)
                        const lastFilledIndex = otpArray.findIndex((d) => d === "");
                        const lastActiveIndex = lastFilledIndex === -1 ? 5 : lastFilledIndex - 1;
                        return (
                            <input
                                key={index}
                                type="text"
                                value={digit}
                                maxLength={1}
                                inputMode="numeric"
                                placeholder=" "
                                className="otpInput"
                                style={{
                                    border: otperror ? "1px solid red" : "",
                                }}
                                ref={(el) => {
                                    if (el) inputRefs.current[index] = el;
                                }}
                                onChange={(e) => handleChange(index, e)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                onFocus={() => {
                                    setKeyboardOpen(true);
                                    // If user tries to focus a previous digit, move focus to last filled/next empty
                                    if (index < lastActiveIndex) {
                                        setTimeout(() => {
                                            const targetIndex = lastFilledIndex === -1 ? 5 : lastFilledIndex;
                                            inputRefs.current[targetIndex]?.focus();
                                        }, 0);
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => {
                                        const stillFocused = inputRefs.current.some(
                                            (input) => input && document.activeElement === input
                                        );
                                        if (!stillFocused) setKeyboardOpen(false);
                                    }, 10);
                                }}
                            />
                        );
                    })}
                </div>

                <p className="otp_sent_text">
                    CKYC has sent a 6 digit OTP to your mobile no
                </p>

                {/* Timer & Resend OTP */}
                <div className="timer_container">
                    {!disableResend && (
                        timer > 0 ? (
                            <span className="time">
                                Resend OTP in <span> {formatTime()}</span>
                            </span>
                        ) : (
                            <span onClick={handleResend} className="link time">
                                Resend
                            </span>
                        )
                    )}


                    {showAadharBtn && (
                        <div className="try_with_aadhar_container">
                            <p>Having trouble with OTP? </p>
                            <p onClick={handleCKYCwithAdhar} className="try_with_aadhar">Complete KYC with Aadhaar</p>
                        </div>
                    )}
                </div>

                {/* ------------- CENTER ---------- */}
                <div style={{ height: "calc(100vh - 700px)" }} />

                {/* ------------------- FOOTER---------------- */}

                <div className="footer">
                    <div style={{ display: keyboardOpen ? "none" : "block" }}>
                        <p className="why_otp_required">
                            Why is this OTP required?
                        </p>

                        <p style={{ fontSize: 12, fontWeight: 500, color: "#7b7b7b" }}>
                            Accessing your KYC from CERSAI helps us instantly verify your
                            details. Enter the OTP to proceed. <br /> <br /> By proceeding, I
                            consent to Akara initiating and completing the KYC checks as per
                            applicable regulatory guidelines.
                        </p>
                        <div className="safe_secure_data">
                            <img src={SHIELD_ICON} alt="Shield Icon" width={24} height={24} />
                            <p style={{ color: "#1F1F1F" }}>Your data is 100% safe & secure</p>
                        </div>
                    </div>
                    <button
                        disabled={!otp || otp.length < 6}
                        type="button"
                        onClick={handleVerifyOTP}
                        className={`verify_btn`}
                    >
                        Verify OTP
                    </button>
                </div>
            </div>

            {/* {pageerror || pagesuccess ? (
        <ToastMessage color={pagesuccess ? "green" : "red"}>
          {pagesuccess ? pagesuccess : pageerror}
        </ToastMessage>
      ) : null}
      {loader && <LoadingComp faded />} */}
            {loader && (
                <div className="loader-wrapper">
                    <div className="loader-content">
                        <div className="loader"></div>
                        <p>Loading...</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CkycOtpInput;